import { FunctionComponent, useContext, useEffect, useState } from "react";
import { CurrentFormContext } from "../contexts";
import { useLocation } from "react-router-dom";
import * as db from "./db";
import { GraphQLResult } from "@aws-amplify/api-graphql";

interface LogRowProperties {
  action: "F" | "S";
  secondary: string;
  location: string;
  agent: string;
}
const LogRow: FunctionComponent<LogRowProperties> = (props) => {
  const colours = {
    F: "green",
    S: "red",
  };
  const actionStyle = {
    backgroundColor: colours[props.action],
  };
  const secondary = () => {
    if (props.secondary) {
      return props.secondary.split(",");
    } else {
      return ["   "];
    }
  };
  let logCount = 0;
  return (
    <tr>
      <td>{props.location}</td>
      <td style={actionStyle}>{props.action}</td>
      <td style={{ padding: "0px", paddingRight: "5px" }}>
        {" "}
        <ul style={{ listStyleType: "none" }}>
          {secondary().map((x) => {
            logCount++;
            return <li key={logCount}>{x}</li>;
          })}
        </ul>{" "}
      </td>
      <td> {+props.agent < 999 ? props.agent.slice(-3) : props.agent} </td>
    </tr>
  );
};

interface LogsProperties {}

interface AgentResponsesByFormResult {
  agentResponsesByForm: {
    items: Log[];
  };
}

interface Log {
  id: string;
  QRCodeBase: string;
  action: "F" | "S";
  agent: string;
  userId: string;
  secondary: string;
  location: string;
  createdAt: string;
  updatedAt: string;
}

const Logs: FunctionComponent<LogsProperties> = () => {
  const { form } = useContext(CurrentFormContext);
  const [responses, setResponses] = useState<Log[]>([]);
  const [path, setPath] = useState<string>("");
  let windowLocation = useLocation();

  useEffect(() => {
    if (windowLocation) {
      setPath(windowLocation.pathname);
    }
  }, [windowLocation]);

  useEffect(() => {
    let actionsUnsubscribe: () => void = () => undefined;
    if (form) {
      (db.getLogsByCodebase(form.QRCodeBase) as Promise<
        GraphQLResult<AgentResponsesByFormResult>
      >).then((logs: GraphQLResult<AgentResponsesByFormResult>) => {
        if (logs.data!.agentResponsesByForm) {
          setResponses(
            logs.data!.agentResponsesByForm.items.sort(
              (a: { createdAt: string }, b: { createdAt: string }) =>
                a.createdAt.localeCompare(b.createdAt)
            )
          );
        }
      });

      const sub = db.subscribeToLogChanges(form.QRCodeBase).subscribe({
        next: (value: Log) =>
          setResponses((currentResponses) => [...currentResponses, value]),
      });

      actionsUnsubscribe = () => sub.unsubscribe();
    } else {
      setResponses([]);
    }

    return actionsUnsubscribe;
  }, [form]);

  return form ? (
    <div
      id="holder"
      className="logs"
      style={{
        display: path !== "/mark" ? "none" : "block",
        visibility: path !== "/mark" ? "hidden" : "visible",
        zIndex: 1000, // Added this because the default z-index of Drawer (Agent Comments) is 1300.
      }}
    >
      <table
        style={{
          borderCollapse: "collapse",
          fontSize: "1em",
          border: "1px solid black",
          maxHeight: "calc(100vh - 70px - 56px)",
          overflow: "scroll",
          display: "block",
        }}
      >
        <tbody>
          {responses.map((item, i) => {
            return (
              <LogRow
                key={i}
                location={item.location || "Roving"}
                action={item.action || "F"}
                agent={item.agent || "BADGE012"}
                secondary={item.secondary || ""}
              />
            );
          })}
        </tbody>
      </table>
    </div>
  ) : null;
};

export default Logs;
